import { dispatchGlobalEvent } from "@storytell/events";
import type { GlobalEventData } from "@storytell/types";
import type { PmInline, PmNode } from "@storytell/types/richText";
import { type Component, Show } from "solid-js";
import { BubbleMenu } from "tiptap-solid";
import type { RichTextEditorInstance } from "../types";

export const EditorBubbleMenu: Component<{
  editor: RichTextEditorInstance | null;
  onQuoteInPromptBar?: (data: GlobalEventData<"quote-in-prompt-bar">) => void;
}> = (props) => {
  return (
    <Show when={props.editor}>
      {(editor) => (
        <BubbleMenu editor={editor()} updateDelay={0} tippyOptions={{ delay: 0, duration: 120, zIndex: 9999 }}>
          <div class="bg-tile border border-primary-border shadow-xl flex items-center gap-2 text-sm rounded-full px-3 overflow-hidden">
            <button
              type="button"
              onClick={() => {
                const { state } = editor();
                const { from, to } = state.selection;
                const text = state.doc.textBetween(from, to, "\n\n");

                // Extract actual nodes from selection
                const nodes: (PmNode | PmInline)[] = [];
                state.doc.nodesBetween(from, to, (node) => {
                  nodes.push(node.toJSON() as PmNode);
                });

                if (nodes.length > 0 && text.trim()) {
                  props.onQuoteInPromptBar?.({
                    quote: nodes,
                    text,
                  });
                }

                dispatchGlobalEvent("close-artifact-panel", undefined);
                dispatchGlobalEvent("focus-prompt-bar", undefined);
              }}
              class="cursor-pointer bg-tile hover:bg-tile-hover h-8 flex items-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-4"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5" />
                <path d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5" />
              </svg>

              <span>Chat with selection</span>
            </button>
          </div>
        </BubbleMenu>
      )}
    </Show>
  );
};
